/* eslint-disable no-unused-vars */
export enum PRINTER_TYPE {
    NONE,
    GT3,
    GTX,
    GTXPRO,
    GTXPRO_BULK,
    GTX300NC,
    GTX600,
    GTX600SB,
    GTX600NBA,
    WF1_L640,
    DTRX100
}

export const PrinterTypeMap = new Map<string, PRINTER_TYPE>([
  ['gt341', PRINTER_TYPE.GT3],
  ['gt361', PRINTER_TYPE.GT3],
  ['gt381', PRINTER_TYPE.GT3],
  ['gt-3', PRINTER_TYPE.GT3],
  ['gtx', PRINTER_TYPE.GTX],
  ['gtx', PRINTER_TYPE.GTX],
  ['gtxpro', PRINTER_TYPE.GTXPRO],
  ['gtxprobulk', PRINTER_TYPE.GTXPRO_BULK],
  ['gtx300nc', PRINTER_TYPE.GTX300NC],
  ['gtx600', PRINTER_TYPE.GTX600],
  ['gtx600sb', PRINTER_TYPE.GTX600SB],
  ['gtx600nba', PRINTER_TYPE.GTX600NBA],
  ['wf1l640', PRINTER_TYPE.WF1_L640],
  ['dtrx100', PRINTER_TYPE.DTRX100],
]);

export enum PRINTER_GUARANTEE_STATUS {

}
/* eslint-enable no-unused-vars */
